import React from 'react';
import ContactUs from "../ContactUs";

export default class AllRightsReserved extends React.Component {

  render() {
    return (
      <p>
        <ContactUs />
        <br />
        &copy;{new Date().getFullYear()} Swift Debt Relief, LLC. All rights reserved.
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/AllRightsReserved/index.js